import { CalculationsProgressBanner } from "#batteries-included-components/Banners/CalculationsProgressBanner";
import { ImportDataActionStatusWithQueue } from "#batteries-included-components/Banners/ImportDataActionStatus";
import { CalculationsTablePanel } from "#src/batteries-included-components";
import { getImportDataActionQueueKey } from "#src/batteries-included-components/Buttons/ImportDataAction/ImportDataAction.helpers";
import { CalculationsViewFilterArea } from "#src/batteries-included-components/FilterAreas/CalculationsFilterAreas";
import { useIsFeatureAvailable } from "#src/contexts/AuthenticatedContext.helpers";
import useLocalization from "#src/hooks/useLocalization";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { NetworkCalcsMeasurementTypes } from "#utils/networkCalculationMeasurementTypeKeys";
import { generateDocumentTitle } from "@validereinc/common-components";
import { AssetType, ResourceDefinitions } from "@validereinc/domain";
import React from "react";
import { Titled } from "react-titled";

const importDataActionQueueKey = getImportDataActionQueueKey({
  resource: {
    id: "estimation_method_config",
    description: "",
    label: {
      singular: "Network Calculation",
      plural: "Network Calculations",
    },
  },
});

export const CalculatorsNetworkTab = () => {
  const { localize } = useLocalization();
  const [isDataIngestionEnabled] = useIsFeatureAvailable({
    featureFlagQuery: "core:data_pipeline",
  });

  const [calcsAndRecordsSharedViewConfigStorageKey] = useStorageKey(
    ["view-configuration"],
    "calculations-records-shared"
  );
  const [
    networkFilterConfigStorageKey,
    networkTableConfigStorageKey,
    networkTableStateStorageKey,
  ] = useStorageKey(
    ["filter-configuration", "table-configuration", "table-state"],
    ["calculations", "calculators", "list", "networks"]
  );
  const [networkCalculationJobStorageKey] = useStorageKey(
    ["async-job"],
    "calculations-emissions-bulk-calculate"
  );
  const measurementTypeFilter = () => false;

  return (
    <>
      <Titled
        title={generateDocumentTitle(
          `${localize("asset_group")} ${ResourceDefinitions.calculator_result.label.plural}`
        )}
      >
        {isDataIngestionEnabled ? (
          <ImportDataActionStatusWithQueue
            queueKey={importDataActionQueueKey}
          />
        ) : null}
        <CalculationsProgressBanner
          jobStorageKey={networkCalculationJobStorageKey}
        />
        <CalculationsViewFilterArea
          viewConfigStorageKey={calcsAndRecordsSharedViewConfigStorageKey}
          isPeriodDateRange
        />
        <CalculationsTablePanel
          filterConfigStorageKey={networkFilterConfigStorageKey}
          tableConfigStorageKey={networkTableConfigStorageKey}
          tableStateStorageKey={networkTableStateStorageKey}
          viewConfigStorageKey={calcsAndRecordsSharedViewConfigStorageKey}
          assetType={AssetType.ASSET_GROUP}
          defaultMeasurementTypes={[...NetworkCalcsMeasurementTypes]}
          measurementTypeFilter={measurementTypeFilter}
          calculationJobStorageKey={networkCalculationJobStorageKey}
        />
      </Titled>
    </>
  );
};
